import {BuyFeatureStates} from '../BuyFeatureStates';
import {BuyFeatureBasicState} from './BuyFeatureBasicState';
import {BuyFeatureWaitingState} from './BuyFeatureWaitingState';
import {BuyFeatureFeatureState} from './BuyFeatureFeatureState';
import {BuyFeatureHiddenState} from './BuyFeatureHiddenState';

export const BuyFeatureFeatureStatesMap = {
    [BuyFeatureStates.BASIC]: BuyFeatureBasicState,
    [BuyFeatureStates.FEATURE]: BuyFeatureFeatureState,
    [BuyFeatureStates.WAITING]: BuyFeatureWaitingState,
    [BuyFeatureStates.HIDDEN]: BuyFeatureHiddenState
};
